<section class="py-12 md:py-20">
  <div class="max-w-5xl mx-auto px-4 sm:px-6">
    <h2
      class="mb-8 md:mb-12 text-2xl sm:text-3xl md:text-4xl font-bold text-center text-(--color-main)"
    >
      الفرص المطروحة
    </h2>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      <div
        class="relative bg-white rounded-xl p-6 sm:p-8 md:p-10 min-h-65 md:min-h-80 text-right flex flex-col"
        dir="rtl"
      >
        <div
          class="absolute top-6 right-6 md:top-8 md:right-8 w-14 h-14 md:w-16 md:h-16 rounded-md bg-(--color-main) flex items-center justify-center"
        >
          <img src="icons/plant-investment.svg" alt="" class="w-7 h-7 md:w-8 md:h-8" />
        </div>

        <div class="mt-24 md:mt-28 flex flex-col flex-1">
          <h3
            class="text-(--color-secondary) text-2xl sm:text-3xl md:text-4xl font-bold mb-6 md:mb-8"
          >
            مبادرة تجارة المحاصيل
          </h3>

          <div
            class="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-4 text-(--color-secondary) text-base md:text-lg lg:text-xl"
          >
            <div class="flex items-center gap-3">
              <i class="fa-solid fa-circle-check text-(--color-main)"></i>
              <span>اولاََ شهري</span>
            </div>

            <div class="flex items-center gap-3">
              <i class="fa-solid fa-circle-check text-(--color-main)"></i>
              <span class="md:whitespace-nowrap">اولاََ موسمي</span>
            </div>

            <div class="flex items-center gap-3">
              <i class="fa-solid fa-circle-check text-(--color-main)"></i>
              <span>اولاََ سنوي</span>
            </div>

            <div class="flex items-center gap-3">
              <i class="fa-solid fa-circle-check text-(--color-main)"></i>
              <span class="md:whitespace-nowrap">اولاََ كل سنتين</span>
            </div>
          </div>

          <div
            class="flex items-center justify-center gap-3 text-(--color-secondary) text-lg sm:text-xl md:text-2xl mt-auto pt-5"
          >
            <span class="cursor-pointer">ابدأ تجارتك الأن</span>
          </div>
        </div>
      </div>

      <div
        class="relative bg-white rounded-xl p-6 sm:p-8 md:p-10 min-h-65 md:min-h-80 text-right flex flex-col"
        dir="rtl"
      >
        <div
          class="absolute top-6 right-6 md:top-8 md:right-8 w-14 h-14 md:w-16 md:h-16 rounded-md bg-(--color-main) flex items-center justify-center"
        >
          <img src="icons/plant-investment.svg" alt="" class="w-7 h-7 md:w-8 md:h-8" />
        </div>

        <div class="mt-24 md:mt-28 flex flex-col flex-1">
          <h3
            class="text-(--color-secondary) text-2xl sm:text-3xl md:text-4xl font-bold mb-6 md:mb-8"
          >
            مبادرة امتلاك أصول عن طريق الأسهم
          </h3>

          <div
            class="flex items-center justify-center gap-3 text-(--color-secondary) text-lg sm:text-xl md:text-2xl mt-auto pt-5"
          >
            <span class="cursor-pointer">ابدأ مساهمتك الأن</span>
          </div>
        </div>
      </div>

      <div
        class="relative bg-white rounded-xl p-6 sm:p-8 md:p-10 min-h-55 md:min-h-65 text-right flex flex-col"
        dir="rtl"
      >
        <div
          class="absolute top-6 right-6 md:top-8 md:right-8 w-14 h-14 md:w-16 md:h-16 rounded-md bg-(--color-main) flex items-center justify-center"
        >
          <img src="icons/plant-investment.svg" alt="" class="w-7 h-7 md:w-8 md:h-8" />
        </div>

        <div class="mt-24 md:mt-28 flex flex-col flex-1">
          <h3 class="text-(--color-secondary) text-2xl sm:text-3xl md:text-4xl font-bold">
            مبادرة إمتلاك أراضي
          </h3>

          <div
            class="flex items-center justify-center gap-3 text-(--color-secondary) text-lg sm:text-xl md:text-2xl mt-auto pt-5"
          >
            <span class="cursor-pointer">ابدأ ملكيتك الأن</span>
          </div>
        </div>
      </div>

      <div
        class="relative bg-white rounded-xl p-6 sm:p-8 md:p-10 min-h-55 md:min-h-65 text-right flex flex-col"
        dir="rtl"
      >
        <div
          class="absolute top-6 right-6 md:top-8 md:right-8 w-14 h-14 md:w-16 md:h-16 rounded-md bg-(--color-main) flex items-center justify-center"
        >
          <img src="icons/plant-investment.svg" alt="" class="w-7 h-7 md:w-8 md:h-8" />
        </div>

        <div class="mt-24 md:mt-28 flex flex-col flex-1">
          <h3 class="text-(--color-secondary) text-2xl sm:text-3xl md:text-4xl font-bold">
            مبادرة إستئجار أراضي
          </h3>

          <div
            class="flex items-center justify-center gap-3 text-(--color-secondary) text-lg sm:text-xl md:text-2xl mt-auto pt-5"
          >
            <span class="cursor-pointer">ابدأ مشروعك الزراعي الأن</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>